import React from "react";
import { Modal, Button, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentlyOpenModal } from "../../redux";
import { getCurrentlyOpenModal } from "../../redux/selectors";
import { dontShowTutorialStorageKeyName, modals } from "../../util/constants";
import DontShowAgain from "../DontShowAgain/DontShowAgain";

export function VideoTutorial() {
  const currentlyOpenModal = useSelector(getCurrentlyOpenModal);
  const open = currentlyOpenModal === modals.videoTutorial;
  const dispatch = useDispatch();
  const onClose = () => dispatch(setCurrentlyOpenModal(""));
  const handleOK = () => {
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={[
        <Space key="footer">
          {" "}
          <DontShowAgain storageKey={dontShowTutorialStorageKeyName}>
            Don't show again
          </DontShowAgain>
          <Button key="ok" onClick={handleOK} type="primary" autoFocus>
            Close
          </Button>
        </Space>,
      ]}
      title="Video Tutorial"
      width="100%"
      style={{ top: "10px" }}
      centered={true}
      destroyOnClose={true}
    >
      <iframe
        style={{ width: "100%", height: "80vh" }}
        src="https://www.youtube.com/embed/oKzK6tN4cUk"
        title="YouTube video player"
        allow="fullscreen; autoplay; clipboard-write; encrypted-media; picture-in-picture"
        allowFullScreen
      />
    </Modal>
  );
}
